import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { NonExchangeDay, NonExchangeDayFilters } from '../../models/NonExchangeDay';
import { fetchDefaultHeaders } from '../shared/vars';

const useNonExchangeDayService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetNonExchangeDays, setFetchingGetNonExchangeDays] = useState(false);
    const [fetchingShowNonExchangeDay, setFetchingShowNonExchangeDay] = useState(false);
    const [fetchingCreateNonExchangeDay, setFetchingCreateNonExchangeDay] = useState(false);
    const [fetchingStoreNonExchangeDay, setFetchingStoreNonExchangeDay] = useState(false);
    const [fetchingEditNonExchangeDay, setFetchingEditNonExchangeDay] = useState(false);
    const [fetchingUpdateNonExchangeDay, setFetchingUpdateNonExchangeDay] = useState(false);
    const [fetchingDeleteNonExchangeDay, setFetchingDeleteNonExchangeDay] = useState(false);
    const [fetchingActiveNonExchangeDay, setFetchingActiveNonExchangeDay] = useState(false);
    const [fetchinggetNonExchangeDaysByDate, setFetchinggetNonExchangeDaysByDate] = useState(false);

    const getNonExchangeDays = (nonExchangeDayFilters: NonExchangeDayFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(nonExchangeDayFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.NON_EXCHANGE_DAYS.GET_NON_EXCHANGE_DAYS}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetNonExchangeDays
        });
    };

    const showNonExchangeDay = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.NON_EXCHANGE_DAYS.SHOW_NON_EXCHANGE_DAY.replace(':id', id.toString()),
            setFetching: setFetchingShowNonExchangeDay
        });
    };

    const createNonExchangeDay = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.NON_EXCHANGE_DAYS.CREATE_NON_EXCHANGE_DAY,
            setFetching: setFetchingCreateNonExchangeDay
        });
    };

    const storeNonExchangeDay = (nonExchangeDay: NonExchangeDay, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.NON_EXCHANGE_DAYS.STORE_NON_EXCHANGE_DAY,
            requestType: 'json',
            headers: {
                'Content-Type': 'application/json',
                ...fetchDefaultHeaders
            },
            body: nonExchangeDay,
            setFetching: setFetchingStoreNonExchangeDay
        });
    };

    const editNonExchangeDay = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.NON_EXCHANGE_DAYS.EDIT_NON_EXCHANGE_DAY.replace(':id', id.toString()),
            setFetching: setFetchingEditNonExchangeDay
        });
    };

    const updateNonExchangeDay = (id: number, nonExchangeDay: NonExchangeDay, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.NON_EXCHANGE_DAYS.UPDATE_NON_EXCHANGE_DAY.replace(':id', id.toString()),
            requestType: 'json',
            headers: {
                'Content-Type': 'application/json',
                ...fetchDefaultHeaders
            },
            body: nonExchangeDay,
            setFetching: setFetchingUpdateNonExchangeDay
        });
    };

    const deleteNonExchangeDay = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.NON_EXCHANGE_DAYS.DELETE_NON_EXCHANGE_DAY.replace(':id', id.toString()),
            setFetching: setFetchingDeleteNonExchangeDay
        });
    };

    const activeNonExchangeDay = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.NON_EXCHANGE_DAYS.ACTIVE_NON_EXCHANGE_DAY.replace(':id', id.toString()),
            body: { is_active: active },
            setFetching: setFetchingActiveNonExchangeDay
        });
    };

    const getNonExchangeDaysByDate = (currencyId: number, year: number, month?: number, events: ServiceEvents = {}) => {
        let url = `${EndPoints.NON_EXCHANGE_DAYS.GET_NON_EXCHANGE_DAYS_BY_DATE}?currency_id=${currencyId}&year=${year}`;
        if (month) {
            url += `&month=${month}`;
        }
        doGet({
            ...events,
            url: url,
            setFetching: setFetchinggetNonExchangeDaysByDate
        });
    };

    return {
        fetchingGetNonExchangeDays,
        fetchingShowNonExchangeDay,
        fetchingCreateNonExchangeDay,
        fetchingStoreNonExchangeDay,
        fetchingEditNonExchangeDay,
        fetchingUpdateNonExchangeDay,
        fetchingDeleteNonExchangeDay,
        fetchingActiveNonExchangeDay,
        fetchinggetNonExchangeDaysByDate,
        getNonExchangeDays,
        showNonExchangeDay,
        createNonExchangeDay,
        storeNonExchangeDay,
        editNonExchangeDay,
        updateNonExchangeDay,
        deleteNonExchangeDay,
        activeNonExchangeDay,
        getNonExchangeDaysByDate
    };
};

export default useNonExchangeDayService; 